<template>
  <main class="ar-split-layout auth-layout flex flex-row min-h-screen">
    <div
      v-if="$arMediaQuery.window.minWidth('sm')"
      class="left-section hidden lg:flex"
    >
      <div class="left-section__inner max-w-[95%] mx-auto relative">
        <img
          :src="backgroundImagePath"
          class="size-full z-10 rounded-lg absolute object-cover hidden lg:block"
          alt="Login Image - Audience Republic"
        >
        <div
          class="inset-0 size-full absolute rounded-lg z-20 hidden lg:block"
          style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);"
        />
        <!-- Audience Republic logo SVG -->
        <svg
          class="absolute z-30 hidden lg:block w-full px-4"
          width="331"
          height="36"
          viewBox="0 0 331 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1255_13892)">
            <path
              d="M62.56 28.5428H67.7513L59.008 3.76196H52.4504L43.707 28.5428H48.8985L50.7428 22.9108H60.7157L62.56 28.5428ZM52.0064 18.9684L54.7729 10.4852C55.0802 9.49959 55.2852 8.19717 55.3193 6.96518C55.3193 6.75398 55.3877 6.47237 55.7292 6.47237C56.0708 6.47237 56.139 6.75398 56.139 6.96518C56.1732 8.19717 56.3781 9.49959 56.6855 10.4852L59.4519 18.9684H52.0064Z"
              fill="white"
            />
            <path
              d="M74.7412 28.8246C77.8833 28.8246 79.8643 26.1846 80.7522 24.3541C80.8888 24.0726 80.9913 23.8613 81.2645 23.9317C81.7086 24.0373 81.5036 24.5301 81.367 24.8469C81.0596 25.5861 80.8205 26.255 80.8205 27.3814V28.5429H85.1922V9.95728H80.8205V17.5253C80.8205 21.8197 78.498 24.7414 75.9707 24.7414C73.6824 24.7414 72.6236 23.5797 72.6236 19.391V9.95728H68.252V20.9397C68.252 26.2197 70.8477 28.8246 74.7412 28.8246Z"
              fill="white"
            />
            <path
              d="M100.971 3.19873V10.6611C100.971 11.4003 101.142 11.9636 101.449 12.5972C101.62 12.9492 101.825 13.3715 101.483 13.5476C101.142 13.7236 100.937 13.266 100.869 13.1252C99.8781 11.0836 97.9655 9.67555 95.1649 9.67555C90.4859 9.67555 87.3096 13.8995 87.3096 19.25C87.3096 24.6004 90.4859 28.8244 95.1649 28.8244C97.8971 28.8244 99.6048 27.2756 100.869 25.3397C100.937 25.234 101.073 24.8821 101.381 24.9876C101.757 25.1284 101.62 25.4804 101.449 25.8324C101.142 26.4661 100.971 27.0292 100.971 27.7332V28.5428H105.342V3.19873H100.971ZM96.1895 24.7413C93.1156 24.7413 91.6813 22.2068 91.6813 19.25C91.6813 16.2932 93.1156 13.7588 96.1895 13.7588C99.0584 13.7588 100.971 16.2932 100.971 19.25C100.971 22.2068 99.0584 24.7413 96.1895 24.7413Z"
              fill="white"
            />
            <path
              d="M108.573 7.70435H112.944V3.19873H108.573V7.70435ZM108.573 28.5428H112.944V9.95716H108.573V28.5428Z"
              fill="white"
            />
            <path
              d="M132.296 19.0035C132.296 12.2451 127.959 9.67554 123.792 9.67554C118.293 9.67554 114.81 13.4419 114.81 19.25C114.81 24.7764 118.02 28.8244 123.861 28.8244C128.676 28.8244 131.204 25.9028 131.989 22.066H127.549C127.037 23.7204 125.978 24.8821 123.895 24.8821C121.163 24.8821 119.387 23.1924 119.079 20.3764H132.194C132.263 19.8484 132.296 19.4964 132.296 19.0035ZM119.25 17.2787C119.694 15.0612 120.958 13.3364 123.929 13.3364C126.456 13.3364 127.754 15.0259 127.925 17.2787H119.25Z"
              fill="white"
            />
            <path
              d="M144.59 9.67554C141.448 9.67554 139.399 12.2804 138.579 14.146C138.442 14.4275 138.34 14.6387 138.066 14.5683C137.623 14.4628 137.828 13.9699 137.964 13.6531C138.306 12.9139 138.51 12.2451 138.51 11.1187V9.95714H134.139V28.5428H138.51V20.9748C138.51 16.6803 140.833 13.7588 143.361 13.7588C145.649 13.7588 146.708 14.9204 146.708 19.1092V28.5428H151.079V17.5604C151.079 12.2804 148.484 9.67554 144.59 9.67554Z"
              fill="white"
            />
            <path
              d="M152.917 19.25C152.917 24.7764 156.537 28.8244 162.036 28.8244C167.125 28.8244 170.096 25.3044 170.403 21.5028H166.1C165.826 23.2628 164.495 24.7412 162.036 24.7412C159.031 24.7412 157.288 22.4884 157.288 19.25C157.288 16.0116 159.031 13.7588 162.036 13.7588C164.495 13.7588 165.826 15.2371 166.1 16.9972H170.403C170.096 13.1955 167.09 9.67554 162.036 9.67554C156.435 9.67554 152.917 13.7235 152.917 19.25Z"
              fill="white"
            />
            <path
              d="M189.307 19.0035C189.307 12.2451 184.97 9.67554 180.803 9.67554C175.303 9.67554 171.82 13.4419 171.82 19.25C171.82 24.7764 175.031 28.8244 180.871 28.8244C185.687 28.8244 188.214 25.9028 188.999 22.066H184.56C184.047 23.7204 182.989 24.8821 180.905 24.8821C178.173 24.8821 176.397 23.1924 176.089 20.3764H189.204C189.273 19.8484 189.307 19.4964 189.307 19.0035ZM176.26 17.2787C176.704 15.0612 177.968 13.3364 180.939 13.3364C183.466 13.3364 184.765 15.0259 184.935 17.2787H176.26Z"
              fill="white"
            />
            <path
              d="M197.821 28.5428H202.465V19.5316H206.154C209.98 19.5316 210.662 20.8692 211.346 23.5092L212.643 28.5428H218.04L215.718 21.9252C215.205 20.4469 214.488 18.546 211.072 18.37C210.833 18.37 210.697 18.1941 210.697 17.9124C210.697 17.5957 210.902 17.49 211.072 17.4548C214.795 16.8212 216.946 14.1812 216.946 11.2948C216.946 7.07078 214.352 3.76196 207.589 3.76196H197.821V28.5428ZM202.465 15.5188V7.91558H208.101C210.731 7.91558 212.302 9.35878 212.302 11.7876C212.302 13.97 209.98 15.5188 207.145 15.5188H202.465Z"
              fill="white"
            />
            <path
              d="M236.287 19.0035C236.287 12.2451 231.95 9.67554 227.783 9.67554C222.283 9.67554 218.8 13.4419 218.8 19.25C218.8 24.7764 222.011 28.8244 227.851 28.8244C232.666 28.8244 235.194 25.9028 235.979 22.066H231.54C231.027 23.7204 229.969 24.8821 227.885 24.8821C225.153 24.8821 223.377 23.1924 223.069 20.3764H236.184C236.253 19.8484 236.287 19.4964 236.287 19.0035ZM223.24 17.2787C223.684 15.0612 224.948 13.3364 227.919 13.3364C230.446 13.3364 231.745 15.0259 231.915 17.2787H223.24Z"
              fill="white"
            />
            <path
              d="M242.5 9.95714H238.129V35.3012H242.5V27.7332C242.5 27.0292 242.33 26.466 242.023 25.8324C241.852 25.4804 241.715 25.1284 242.091 24.9876C242.398 24.8821 242.535 25.234 242.603 25.3396C243.696 27.3812 245.575 28.8244 248.307 28.8244C252.986 28.8244 256.163 24.6004 256.163 19.25C256.163 13.8995 252.986 9.67554 248.307 9.67554C245.506 9.67554 243.696 11.1539 242.603 13.1251C242.535 13.2659 242.33 13.7235 241.989 13.5476C241.647 13.3715 241.886 12.9492 242.023 12.5971C242.33 11.9636 242.5 11.4003 242.5 10.6611V9.95714ZM247.282 24.7412C244.414 24.7412 242.5 22.2068 242.5 19.25C242.5 16.2931 244.414 13.7588 247.282 13.7588C250.356 13.7588 251.791 16.2931 251.791 19.25C251.791 22.2068 250.356 24.7412 247.282 24.7412Z"
              fill="white"
            />
            <path
              d="M264.51 28.8246C267.652 28.8246 269.632 26.1846 270.521 24.3541C270.657 24.0726 270.759 23.8613 271.033 23.9317C271.477 24.0373 271.272 24.5301 271.135 24.8469C270.828 25.5861 270.589 26.255 270.589 27.3814V28.5429H274.96V9.95728H270.589V17.5253C270.589 21.8197 268.266 24.7414 265.739 24.7414C263.45 24.7414 262.391 23.5797 262.391 19.391V9.95728H258.021V20.9397C258.021 26.2197 260.615 28.8246 264.51 28.8246Z"
              fill="white"
            />
            <path
              d="M282.542 3.19873H278.17V28.5428H282.542V27.7332C282.542 27.0292 282.371 26.4661 282.064 25.8324C281.893 25.4804 281.757 25.1284 282.132 24.9876C282.439 24.8821 282.576 25.234 282.644 25.3397C283.737 27.3813 285.615 28.8244 288.348 28.8244C293.027 28.8244 296.203 24.6004 296.203 19.25C296.203 13.8995 293.027 9.67555 288.348 9.67555C285.548 9.67555 283.737 11.154 282.644 13.1252C282.576 13.266 282.371 13.7236 282.03 13.5476C281.688 13.3715 281.927 12.9492 282.064 12.5972C282.371 11.9636 282.542 11.4003 282.542 10.6611V3.19873ZM287.324 24.7413C284.454 24.7413 282.542 22.2068 282.542 19.25C282.542 16.2932 284.454 13.7588 287.324 13.7588C290.397 13.7588 291.832 16.2932 291.832 19.25C291.832 22.2068 290.397 24.7413 287.324 24.7413Z"
              fill="white"
            />
            <path
              d="M298.341 3.19873V28.5428H302.713V3.19873H298.341Z"
              fill="white"
            />
            <path
              d="M305.937 7.70435H310.309V3.19873H305.937V7.70435ZM305.937 28.5428H310.309V9.95716H305.937V28.5428Z"
              fill="white"
            />
            <path
              d="M312.174 19.25C312.174 24.7764 315.795 28.8244 321.293 28.8244C326.383 28.8244 329.354 25.3044 329.661 21.5028H325.358C325.084 23.2628 323.753 24.7412 321.293 24.7412C318.287 24.7412 316.546 22.4884 316.546 19.25C316.546 16.0116 318.287 13.7588 321.293 13.7588C323.753 13.7588 325.084 15.2371 325.358 16.9972H329.661C329.354 13.1955 326.348 9.67554 321.293 9.67554C315.693 9.67554 312.174 13.7235 312.174 19.25Z"
              fill="white"
            />
            <path
              d="M8.7677 28.2567C8.7677 30.4824 7.00413 32.2893 4.82575 32.2893C2.64737 32.2893 0.883789 30.4851 0.883789 28.2567C0.883789 26.0283 2.64737 24.2243 4.82575 24.2243C7.00413 24.2243 8.7677 26.0283 8.7677 28.2567ZM21.6869 25.7221C21.0991 24.9858 20.3272 24.5193 19.503 24.3282C18.1075 24.0022 16.1819 23.4992 15.4594 22.2346L15.2919 21.9424C14.5529 20.6469 15.1463 18.6602 15.5281 17.2158C15.9044 15.7826 15.4979 14.1808 14.3057 13.1186C12.8305 11.8035 10.589 11.8119 9.12207 13.1354C7.3997 14.6894 7.33652 17.3816 8.93527 19.017C9.4627 19.5566 10.1 19.9107 10.773 20.0793C12.185 20.4361 14.1546 20.8999 14.888 22.1869L15.0557 22.4819C15.7946 23.7774 15.1958 25.767 14.8139 27.217C14.4595 28.563 14.8002 30.0609 15.833 31.1175C17.4318 32.7529 20.0661 32.6884 21.5825 30.9236C22.8407 29.4623 22.8873 27.2395 21.6841 25.7305L21.6869 25.7221ZM35.4823 25.7221C34.8917 24.983 34.1172 24.5164 33.2903 24.3254C31.8975 24.0022 29.9499 23.5301 29.2302 22.2712L29.0461 21.948C28.3154 20.6694 28.9281 18.6714 29.3153 17.2467C29.6835 15.8922 29.3483 14.3776 28.3072 13.3125C27.7715 12.7645 27.1178 12.4048 26.431 12.239C25.0355 11.9018 23.0632 11.4578 22.3379 10.1904L22.1512 9.86167C21.4232 8.58587 22.033 6.5991 22.4203 5.17718C22.8131 3.73558 22.4093 2.11696 21.2062 1.04629C19.731 -0.268845 17.4895 -0.260415 16.0226 1.06315C14.3001 2.61715 14.237 5.30925 15.8358 6.94475C16.3715 7.49273 17.0224 7.84961 17.7092 8.01541C19.1019 8.35262 21.0688 8.79943 21.7912 10.064L21.9863 10.404C22.7143 11.677 22.1072 13.6637 21.7226 15.0857C21.3572 16.4402 21.6923 17.9492 22.7335 19.0143C23.2692 19.5622 23.9175 19.9191 24.6042 20.0849C25.9969 20.425 27.9528 20.8662 28.6726 22.1307L28.8786 22.4903C29.6065 23.7662 29.0077 25.7558 28.6203 27.1805C28.2523 28.535 28.5902 30.0468 29.6312 31.1118C31.23 32.7474 33.8644 32.6827 35.3807 30.9179C36.6389 29.4567 36.6855 27.2338 35.4823 25.7248V25.7221Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1255_13892">
              <rect
                width="330"
                height="35.8696"
                fill="white"
                transform="translate(0.200195 0.0651855)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div
      ref="page-content"
      class="h-screen flex flex-row"
      :class="[
        'page-content',
        $arMediaQuery.window.maxWidth('sm') && 'full-width',
      ]"
    >
      <slot />
    </div>

    <div
      class="logo-wrapper fixed top-[37px] left-[35px] z-50 inline-flex w-[50px] h-[50px] rounded-full items-center justify-center"
      :class="$arMediaQuery.window.maxWidth('md') ? 'absolute bg-white/90' : ''"
    >
      <AM3Icon
        v-if="$arMediaQuery.window.maxWidth('md')"
        type="ar-logo"
        size="md"
        color="brand"
      />
    </div>
  </main>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted } from 'vue'
import { getContext } from '@/utils/general'
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'

const { $arMediaQuery } = getContext()

const backgroundImagePath = '/login.jpg'

const updateMediaQuery = () => {
  const { $updateArMediaQuery } = getContext()
  const windowWidth = window.innerWidth
  const pageContentWidth = window.innerWidth > $arMediaQuery.sizeMap.sm.max ? parseInt(window.innerWidth / 2) : windowWidth
  $updateArMediaQuery({
    windowWidth,
    pageContentWidth,
  })
}

onMounted(() => {
  window.addEventListener('resize', updateMediaQuery)
  updateMediaQuery()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateMediaQuery)
})
</script>

<style scoped>
.ar-split-layout {
  position: relative;
  display: flex;
}
.ar-split-layout .left-section {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  padding: 32px;
  @apply lg:w-[36vw];
}
.ar-split-layout .left-section__inner {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ar-split-layout .page-content {
  width: 100%;
  @apply lg:ml-[36vw];
}
.ar-split-layout .page-content.full-width {
  width: 100vw;
  margin-left: 0;
}
</style>
